import styled from 'styled-components';

export const AppStyled = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  min-height: 100%;
  height:100%;
  // flex: 1 4;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
  // background-color: ${(props) => props.theme.colors.black};
  background: transparent;

  overflow: hidden; /* Hide scrollbars */

  @media screen and (max-width: ${(props) => props.theme.sizes.mobile}) {
    .box {
      // border: 10px solid yellow;
      order: -1;
    }
  }
`;

export const BoxColumns = styled.div`
  width: 100%;
  /* display:block;
  box-sizing: border-box;
  position: relative; */
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-flow: columns;
  overflow: hidden; /* Hide scrollbars */
  background: transparent;
`;

export const ViewerWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  background: transparent;
`;
